import { useEffect } from "react";
import { useMeQuery } from "queries";
import { onOpenPreferencesPopup } from "buses";

export const useCheckPreferences = () => {
  const { data } = useMeQuery();

  useEffect(() => {
    console.debug("Visitor info changes, checking for preferences.");

    if (!data) {
      return;
    }

    const countPreferences = data.preferences?.length || 0;

    if (countPreferences > 0) {
      return;
    }

    onOpenPreferencesPopup();
    console.debug("Showing the preferences dialog.");
  }, [data]);
};
